module.exports = __webpack_public_path__ + "img/1.e2185560.png";